import React, { useState, useEffect, useRef } from 'react';
import CourseManagement from './CourseManagement';
import StudentAnalytics from './StudentAnalytics';
import Earnings from './Earnings';
import './Instructor.css';
import { FaPen } from 'react-icons/fa';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import PaymentInfo from './PaymentInfo'; 
import { INSTRUCTOR_URL } from '../../Services/Services';
import { ClipLoader } from 'react-spinners';

const Instructor = () => {
    const [activeSection, setActiveSection] = useState('CourseManagement');
    const [isMobile, setIsMobile] = useState(false);
    const [loading, setLoading] = useState(false);
    const { t } = useTranslation();
    const instructorId = localStorage.getItem('userId'); 
    const token = localStorage.getItem("token");
    const fullName = localStorage.getItem('fullName');
    const firstLetter = fullName ? fullName.charAt(0).toUpperCase() : '';
    const navigate = useNavigate();
    const profilePicture = localStorage.getItem('profilePictureUrl');
 
    const courseManagementRef = useRef(null);
    const earningsRef = useRef(null);
    const paymentInfoRef = useRef(null);

    useEffect(() => {
        if (!token) {
            navigate('/login');
        }
        const handleResize = () => {
            setIsMobile(window.innerWidth < 768);
        };

        handleResize();
        window.addEventListener('resize', handleResize);

        return () => window.removeEventListener('resize', handleResize);
    }, [navigate, token]);

    
 
  useEffect(() => {
    if (instructorId) {
      setLoading(true);

      const fetchApprovalStatus = async () => {
        try {
          const response = await fetch(`${INSTRUCTOR_URL}/approval-status/${instructorId}`);
          const data = await response.json();
          data[0] !== "APPROVED" && navigate('/');
        } catch (error) {
          console.error('Error fetching approval status:', error);
        } finally {
          setLoading(false);
        }
      };

      fetchApprovalStatus();
    }
  }, [instructorId, navigate]);

    const getGreeting = () => {
        const hours = new Date().getHours();
        if (hours >= 5 && hours < 12) {
            return "Good Morning";
        } else if (hours >= 12 && hours < 18) {
            return "Good Afternoon";
        } else if (hours >= 18 && hours < 21) {
            return "Good Evening";
        } else {
            return "Good Night";
        }
    };

    const getProfileImage = () => {
        if (profilePicture && profilePicture !== 'null' && profilePicture !== '') {
            return profilePicture;
        }
        return firstLetter;
    };

    const renderSection = () => {
        switch (activeSection) {
            case 'CourseManagement':
                return <CourseManagement setActiveSectionFunc={setActiveSectionFunc}/>;
            case 'StudentAnalytics':
                return <StudentAnalytics />;
            case 'EarningsOverview':
                return <Earnings  setActiveSectionFunc={setActiveSectionFunc}/>;
            case 'PaymentInfo':
                return <PaymentInfo />;
            default:
                return <div>{t('SelectASection')}</div>;
        }
    };
 
 

    const setActiveSectionFunc=(value)=>{
        setActiveSection(value);
    }

    return (
        <div className="instructor-page">
            <div className="i-sidebar">
                {isMobile ? (
                    <select
                        value={activeSection}
                        onChange={(e) => setActiveSection(e.target.value)}
                        className="dropdown"
                    >
                        <option value="CourseManagement">{t('CourseManagement')}</option>
                        <option value="EarningsOverview">{t('EarningsOverview')}</option>
                        <option value="PaymentInfo">{t('Payment Info')}</option>
                    </select>
                ) : (
                    <>
                        <button
                            className={activeSection === 'CourseManagement' ? 'active' : ''}
                            onClick={() => setActiveSection('CourseManagement')}
                        >
                            {t('CourseManagement')}
                        </button>
                        <button
                            className={activeSection === 'EarningsOverview' ? 'active' : ''}
                            onClick={() => setActiveSection('EarningsOverview')}
                        >
                            {t('EarningsOverview')}
                        </button>
                        <button
                            className={activeSection === 'PaymentInfo' ? 'active' : ''}
                            onClick={ ()=>  setActiveSection('PaymentInfo')}
                        >
                            {t('Payment Info')}
                        </button>
                    </>
                )}
            </div>
            <div className="i-content">
                <div className='image-container'>
                    {profilePicture && profilePicture !== 'null' && profilePicture !== '' ? (
                        <img src={getProfileImage()} alt="profile" className="instructor-image" />
                    ) : (
                        <p className="instructor-image" >
                            {getProfileImage()}
                        </p>
                    )}
                    <label htmlFor="imageUpload">
                        <FaPen style={{ cursor: 'pointer' }} color={'white'} />
                    </label>
                    <input
                        id="imageUpload"
                        type="file"
                        accept="image/*"
                        style={{ display: 'none' }}
                    />
                    <h2>Hello {fullName},<span className='greeting-text'> {getGreeting()}</span> </h2>
                </div>
                <div>
                    {renderSection()}
                </div>
            </div>

            <div id="courseManagement" ref={courseManagementRef}></div>
            <div id="earningsOverview" ref={earningsRef}></div>
            <div id="paymentInfo" ref={paymentInfoRef}></div>
            {loading && (
          <div className="loading-overlay">
            <ClipLoader color="#333333" loading={loading} size={50} />
          </div>
        )}
        </div>
    );
};

export default Instructor;
